import type { SingleAction } from './types';

import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import BaseModal, { ModalBody, ModalHeader } from '__components/Modals';
import { ActionButtonWrapper, ActionButtons } from './ActionButtons';

const StyledModalBody = styled(ModalBody)`
  overflow-y: auto; // Removes unnecessary scrollbar, which allows things to size/align per designs
  overflow-x: hidden;
  margin-bottom: 15px;
`;

type PerformSingleActionModalProps = {
  fullName: string;
  performActionOptions: SingleAction[];
  show: boolean;
  onHide(): void;
  onSelect(data: SingleAction): void;
};

export const PerformSingleActionModal = ({
  fullName,
  performActionOptions,
  show,
  onHide,
  onSelect,
}: PerformSingleActionModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal size="medium" onHide={onHide} show={show}>
      <ModalHeader onClickClose={onHide}>
        {`${t('Perform Action on')} ${fullName}`}
      </ModalHeader>
      <StyledModalBody>
        <ActionButtonWrapper>
          <ActionButtons
            onSelect={onSelect}
            performActionOptions={performActionOptions}
          />
        </ActionButtonWrapper>
      </StyledModalBody>
    </BaseModal>
  );
};
